export default "__VITE_ASSET__B1yMljOz__"